import React, { useState } from 'react';

const ConfirmationModal = ({ message, onNext, onBack }) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 mx-4 rounded-xl shadow-xl w-full max-w-md text-right relative">
        
        {/* כפתור חזור */}
        <button
          onClick={onBack}
          className="absolute top-4 left-4 text-gray-500 hover:text-red-600 text-xl font-bold"
          aria-label="סגור"
        >
             ←
          {/* ✕ */}
        </button>

        <h2 className="text-xl font-semibold mb-4 text-gray-800">אישור פעולה</h2>
        <p className="text-gray-700 mb-4">{message}</p>

        <div className="flex flex-row-reverse items-center mb-6">
          <input
            type="checkbox"
            id="confirmation"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className="ml-2"
          />
          <label htmlFor="confirmation" className="text-sm text-gray-800 cursor-pointer">
            אני מאשר/ת את תנאי הפעולה
          </label>
          
        </div>

        <button
          disabled={!isChecked}
          onClick={onNext}
          className={`w-full py-2 rounded-lg font-semibold transition 
            ${isChecked ? 'bg-[#00c853] text-white hover:bg-green-500' : 'bg-gray-300 text-gray-600 cursor-not-allowed'}`}
        >
          המשך לתשלום
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
